module.exports = __webpack_public_path__ + "img/player_jump_001.cdee192c.png";